import { getLocale } from "../../../../services/storage-window"

export default {
    locale : getLocale() || null
}
